import React, { useEffect, useState } from "react"
import { ClienteInfo } from "../cliente-info";
import { ContratosAcordo } from "./components/contratos";
import { CanaisEnvio } from './components/canais-envio/CanalEnvioTesteRefeito'
import { AcordoSegundaViaAccordion } from './components/resumo/components/acordo'
import { useNeg } from "../../../../../context/NegContext";
import { GenericModal } from "../../../../Modal";
import { useModal } from "../../../../../hooks/ModalContext";
import { useAuth } from "../../../../../context/AuthContext";
import { useBoleto } from "../../../../../context/BoletoContext";
import { usePropostas } from "../../../../../context/PropostasContext";
import { useDividas } from "../../../../../context/DividasContext";

interface SegundaViaProps {
  app?: string
}

export const SegundaVia = ({ app }: SegundaViaProps) => {
  const { acordoResponse, parcelaAcordo } = useNeg()
  const { modalInfo, onClose, setModal } = useModal()
  const { canalEnvio } = usePropostas()
  const { cookies } = useAuth();
  const { selectedCredor, devedor } = useDividas();
  const { enviarBoleto, boleto } = useBoleto();

  const [canal, setCanal] = useState<{ canal: string; destino: string }[]>([]);

  const formasPagamentos = [
    {
      id: '1',
      forma: 'Boleto'
    },
    {
      id: '4',
      forma: 'PIX'
    },
    {
      id: '5',
      forma: 'Pgto em loja'
    },
  ]

  useEffect(() => {
    if (canalEnvio.canalrecebimento === 'email;sms') {
      const [canalEmail, canalSms] = canalEnvio.destinorecebimento.split(';');
      setCanal([
        {
          canal: 'email',
          destino: canalEmail,
        },
        {
          canal: 'sms',
          destino: canalSms,
        },
      ]);
    } else {
      setCanal([{ canal: canalEnvio.canalrecebimento, destino: canalEnvio.destinorecebimento }]);
    }
  }, [canalEnvio]);

  function formatarTelefone(telefone: string) {
    if (telefone && telefone !== '') {
      telefone = telefone.replace(/\D/g, '');
      telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
      return telefone;
    }
    return '';
  }
  function goToOpeningAccordion() {
    const element = document.getElementById('acordo');
    if (element) {
      document.getElementById('acordo')?.setAttribute('open', 'true');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }


  async function concluirAcordo() {
    if (
      acordoResponse?.codigoacordo &&
      canalEnvio.destinorecebimento !== '' &&
      canalEnvio.canalrecebimento !== ''
    ) {
      if (canalEnvio.canalrecebimento === 'email;sms') {
        const [email, sms] = canalEnvio.destinorecebimento.split(';');
        if (email === '' || sms === '') {
          setModal('Selecione uma proposta e canal de envio primeiro', 'Aviso', false, false, true);
          return;
        }
      }
    }

    const data = {
      url: selectedCredor.url_ws,
      codcredor: String(selectedCredor.credor_crm),
      contrato: acordoResponse.contrato,
      cpf_cnpj: devedor?.cpf_cnpj || '',
      canalrecebimento: canalEnvio?.canalrecebimento || '',
      destinorecebimento: canalEnvio?.destinorecebimento || '',
      vencimento: parcelaAcordo?.datvenci,
      formapagamento: acordoResponse?.formapagamento,
      modo: '0',
      app: app ? app : 'ACIONA_OPE',
      usuario: String(cookies?.user?.id_operador),
    }
    await enviarBoleto(data, cookies?.user?.id_operador)

  }

  async function handleAcordo() {
    await concluirAcordo();
    goToOpeningAccordion();
  }
  return (
    <div className="flex max-h-full flex-col items-center px-2 ">
      <>
        <div className="my-2 w-full px-4">
          <ClienteInfo />
        </div>

        <div className="my-2 w-full px-4">
          <ContratosAcordo app={app} />
        </div>

        {
          !acordoResponse?.formapagamento || (acordoResponse && boleto?.url) || (acordoResponse && acordoResponse?.formapagamento === '5') || (acordoResponse && acordoResponse?.formapagamento === '5' && boleto?.url) ? <></>
            : <div className="w-full px-4">
              <CanaisEnvio />
            </div>
        }

        {
          !boleto?.url && <button
            onClick={() => handleAcordo()}
            className="flex w-[97%] items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white"
          >
            Enviar 2ª via
          </button>
        }


        <div className="my-2 w-full px-4">
          <AcordoSegundaViaAccordion formaPag={formasPagamentos.find(item => item.id === acordoResponse?.formapagamento || '')?.forma || ''} app={app} />
        </div>

        <GenericModal
          title={modalInfo.title}
          type={modalInfo.type}
          onClose={() => onClose()}
          show={modalInfo.isOpen}
          modalType="Cadastro Contato"
          isToSave
          app={app}
        />

      </>
    </div>
  )
}